import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
	Component,
	OnInit,
	Input,

	ViewChild,
	OnChanges,
	OnDestroy,
	HostListener,
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { getFirebaseBackend } from 'src/app/authUtils';
import { OldDataService } from 'src/app/core/services/old-data.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs';
import { TITLES } from '../constants';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { OrdersService } from 'src/app/services/orders/orders.service';
import { RescheduleService } from 'src/app/services/rescheduled/reschedule.service';
import { SelectedOptionsService } from 'src/app/services/selected-options/selected-options.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { LeadService } from 'src/app/services/lead/lead.service';
import { CampaignService } from 'src/app/services/campaigns/campaign.service';
import { ProspectsService } from 'src/app/services/prospects/prospects.service';
import { ReplacementService } from 'src/app/services/replacement/replacement.service';
import dayjs from 'dayjs';


@Component({
	selector: 'lead-edit',
	templateUrl: './lead-edit.component.html',
	styleUrls: ['./lead-edit.component.scss']
})

export class LeadEditComponent implements OnInit, OnChanges, OnDestroy {

	@Input() ID: number = 0;

	public user: any;
	public leadId: number;
	@ViewChild('modal_notes') modal_notes: NgbModal;

	public today: Date = new Date();

	public lead: any = null; //Aqui esta toda la info de la pantalla details
	public beforeReplacementStatus;
	public leadMsg: string = null;
	public leadLoading: boolean = true;
	public campaignId = 0;
	client_notes: any;
	messageError: string = "";
	messageSuccess: string = "";
	loadingSaveNote: boolean = false;
	client_input: boolean = false;

	public titles: any = [];

	public activeTab: string = 'details';

	public activeCampaigns: any = [];
	public activeCampaign: number = null;

	public from: string = '';

	public leadQcNotes: string = '';
	notes_qc: any = [];

	public leadsChanges: any = [];
	public formData = {
		client_notes_area: ''
	};
	copyNotes = '';


	public confVmFullDate = null;
	public contactedFulldate = null;
	public remplacedFullDate = null;
	public dateCharged = null;

	public employeeId: string = ''

	public confirmationStatus: string = '';
	public remplacementStatus: string = '';
	public uploadedRecording: string = '';
	public audioUrl: string = '';

	public callSheetTab: string = 'details';
	public campaign_info = null;
	public camapignInfoLoading: boolean = false;

	public client: any = null;
	public leadNumber: number = 0;

	public client_satisfaction = '';
	public client_feedbak = '';

	public trueimg: Boolean = false;
	public loader: Boolean = false;
	public myimg: string;
	public final: Boolean = true;
	public msn: string;

	public uploadedFiles: any = [];

	public uploading: boolean = false;

	public showing = 'Files';
	public audio_name = '';
	public audio_url = '';

	public closeResult = '';
	public reschedule = {
		id: null,
		lead_id: 0,
		alias: '',
		new_date: null,
		newHour: '06',
		newMin: '00',
		ampm: 'PM',
		reason: '',
		status: 'Pending',
		resolved_by: null,
		newTime: '',
		calendar_id: null,
		user_login: null,
		user_id: null,
		send_notification: false
	}

	public newTime;

	public isReschedule = false;

	public badHour = false;
	public badMin = false;
	public isEnabled = false;
	//Back Options

	public searchCampaignId;
	public searchAgentLogin;
	public dateOf;
	public fromDate;
	public toDate;
	public toView;
	public backUrl;

	public user_id;

	public posibleReplaceLeads = [];
	public replacedBy;
	public wasClear = false;

	public downloading = false;

	public allDispos: any = [];
	public msgDispos: any = [];
	public leadDispos: any = [];
	public lastNote: string = null;
	public client_notes_display: boolean = false;
	public client_feedback_display: boolean = false;
	public reschedule_reason_display: boolean = false;
	public showRescheduleBtn: boolean = false;
	public difficult = "Easy";
	public triggerSubscription: Subscription;
	public audioAvailable: boolean;
	public audioUrl2: string;
	notes: any = [];
	showMoreNotes = false;

	public loading = false;
	public activityPanelOpen = true;
	constructor(
		private router: Router,
		private dataService: OldDataService,
		private route: ActivatedRoute,
		public authenticationService: AuthenticationService,
		private modalService: NgbModal,
		private http: HttpClient,
		private utils: UtilsService,
		private selectedOptions: SelectedOptionsService,
		private rescheduleService: RescheduleService,
		private replacementSrv: ReplacementService,
		private leadSrv: LeadService,
		private orderService: OrdersService,
		private campaignSrv: CampaignService,
		private prospectSrv: ProspectsService
	) {
		// this.user = this.authenticationService.currentUserValue;
		this.user = getFirebaseBackend()?.getAuthenticatedUser();
		// console.log(this.user);
		this.leadId = parseInt(this.route.snapshot.paramMap.get("selectedLead"));
		this.audioAvailable = false;
		this.audioUrl2 = `${environment.api}ringcentral/get_audio/`;

	}

	ngOnInit() {

		if (this.ID != 0) {
			this.leadId = this.ID;
		}

		this.wasClear = false;
		this.getLeadById();
		this.getActiveCampaigns();
		this.get_customer_notes_bylead();
		this.titles = TITLES;
		this.triggerSubscription = this.selectedOptions.triggerBackButton.subscribe(data => {
			this.saveLead();
		});

		this.getQcLeadNotes();

	}

	ngOnChanges(): void {
	}

	ngOnDestroy() {
		this.triggerSubscription.unsubscribe();
	}

	@HostListener('window:popstate', ['$event'])
	onPopState(event: Event) {
	  this.backButton();
	  history.pushState(null, '', window.location.href);
	}

	pad(n, width, z) {
		z = z || '0';
		n = n + '';
		return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
	}

	goToCalendar() {
		this.router.navigate(['/campaign-calendar/' + this.lead.campaign_id]);
	}

	goToAllCalendar() {
		this.router.navigate(['/all-campaign-calendar/']);
	}

	getActiveCampaigns() {
		this.activeCampaigns = [];
		this.campaignSrv.getCampaignsForSelect('1').subscribe((data: any) => {
			this.activeCampaigns = data.body;
		});
	}

	getLeadById() {

		this.leadSrv.lead_detail(this.leadId).subscribe((data: any) => {
			this.lead = data.body;
			this.lead.new_qc_notes = '';
			this.beforeReplacementStatus = this.lead.replacement_status;
			this.lead.old_qc_notes = this.lead.qc_notes;
			this.reschedule.new_date = this.utils.phptoNgbDate(this.lead.start_date);
			this.campaignId = this.lead.campaign_id;
			this.audioUrl2 += this.lead.rc_call_id;
			if (this.lead.client_feedback != '' && this.lead.client_feedback != null) {
				this.client_feedback_display = true;
			}
			if (this.lead.reschedule_reason != '' && this.lead.reschedule_reason != null) {
				this.reschedule_reason_display = true;
			}

			if (this.lead.client_satisfaction != 0) {
				this.answered = true;
			}

			if (this.lead.confirmation_voicemail_date != null) {
				this.lead.confirmation_voicemail_date = this.utils.phptoNgbDate(this.lead.confirmation_voicemail_date);
			}

			if (this.lead.contacted_date != null) {
				this.lead.contacted_date = this.utils.phptoNgbDate(this.lead.contacted_date);
			}

			if (this.lead.remplaced_date != null) {
				this.lead.remplaced_date = this.utils.phptoNgbDate(this.lead.remplaced_date);
			}

			if (this.lead.date_charged != null) {
				this.lead.date_charged = this.utils.phptoNgbDate(this.lead.date_charged);
			}

			this.getAllDisposByPrimaryPhone(this.lead.primary_phone);
			this.leadLoading = false;
			this.getDispoLogNotes();

		});
	}

	openCalendar(id, alias) {
		var url = this.router.url;
		var urlArray = url.split('/');
		url = `${urlArray[0]}/#/calendar/${alias}/${id}`;
		window.open(url, '_blank', 'location=no,height=825,width=1200,scrollbars=yes,status=yes');
	}



	get_customer_notes_bylead() {
		this.messageError = "";
		this.leadSrv.get_customer_notes_bylead(this.leadId).subscribe(data => {
			if (data) {
				this.client_notes = data.body;
			} else {
				this.messageError = "Endpoint Failed, please check with support area"
			}
		});
	}

	backToLeads() {
		this.router.navigate(['/admin-portal']);
	}

	approveLeadById() {
		if (this.lead.lead_status == 'Approved') {
			Swal.fire({
				title: 'Already Approved',
				text: 'This lead is already approved',
				showCancelButton: false,
				confirmButtonText: 'Ok',
				cancelButtonText: 'Cancel'
			});
		} else {
			this.leadLoading = true;
			//validar lead reserve
			this.leadSrv.getLeadCampaign(this.leadId).then(data => {
				this.getOrderData(data.body.id);
			});

		}
	}



	confirmReplacementFree() {
		Swal.fire({
			title: 'Approve Replacement for FREE',
			text: 'Are you sure to approve this replacement as free?',
			showCancelButton: true,
			showConfirmButton: true
		}).then(data => {
			this.replacementSrv.setReplacementFree(this.lead.id, this.lead.alias, this.user.IdUser).subscribe(data => {
				console.info(data);
			})
		})
	}

	confirmReplacementCharge() {
		if (isNaN(this.lead.replacement_cost) || this.lead.replacement_cost <= 0) {
			Swal.fire({
				title: "Error on Replacement cost",
				text: `The replacement cost has an error, this is the value obtained: "${this.lead.replacement_cost}" please contact admin.`,
				showCancelButton: false,
				showConfirmButton: true,
				confirmButtonText: "Ok"
			});
			return;
		}

		Swal.fire({
			title: 'Approve Replacement with Fee',
			text: `Are you sure to charge $${this.lead.replacement_cost} for this replacement?`,
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: "Send notification to the client"
		}).then(data => {

			this.replacementSrv.setReplacementCharge(this.lead.id, this.lead.replacement_cost, this.lead.alias, this.user.IdUser).subscribe(data => {
				this.getLeadById();
			})
		})
	}

	alertRescheduleCharge(title: string, text: string) {

	}

	confirmRescheduleFree() {
		Swal.fire({
			title: 'Approve Reschedule for FREE',
			text: 'Are you sure to approve this reschedule as free?',
			showCancelButton: true,
			showConfirmButton: true
		}).then(data => {
			this.rescheduleService.setRescheduleFree(this.lead.id, this.lead.alias, this.user.IdUser).subscribe(data => {
				console.info(data);
				Swal.fire({
					title: 'Success',
					text: 'Reschedule approved as free',
					showCancelButton: false,
					confirmButtonText: 'Ok' });
			});
		})
	}

	confirmRescheduleCharge() {
		if (isNaN(this.lead.reschedule_cost) || this.lead.reschedule_cost <= 0) {
			Swal.fire({
				title: "Error on Reschedule cost",
				text: `The reschedule cost has an error, this is the value obtained: "${this.lead.reschedule_cost}" please contact admin.`,
				showCancelButton: false,
				showConfirmButton: true,
				confirmButtonText: "Ok"
			});
			return;
		}

		Swal.fire({
			title: 'Approve Reschedule with Fee',
			text: `Are you sure to charge $${this.lead.reschedule_cost} for this reschedule?`,
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: "Send notification to the client"
		}).then(data => {

			this.rescheduleService.setRescheduleCharge(this.lead.id, this.lead.reschedule_cost, this.lead.alias, this.user.IdUser).subscribe(data => {
				this.getLeadById();
				Swal.fire({	title: 'Success',
							text: 'Reschedule approved with fee',
							showCancelButton: false,
							confirmButtonText: 'Ok' });
			})
		})
	}

	requestApprovedLead() {
		this.leadLoading = true;
		const payload = { lead_id: this.leadId, user: this.user.Login, user_id: this.user.IdUser }
		this.leadSrv.approve_lead(payload).subscribe(
			data => {
				Swal.fire({
					icon: 'success',
					title: 'Lead Correctly approved'
				});
				this.lead.lead_status = 'Approved';
				this.leadLoading = false;
			},
			error => {
				Swal.fire({
					icon: 'error',
					title: 'Error approving lead ',
					text: 'See the console for further information'
				});
				console.error('Error approving lead:', error);
				this.leadLoading = false;

			}
		);
	}

	getOrderData(id) {
		this.orderService.getDataOrderByCampaign_all(id)
			.subscribe((data: any) => {
				if (!data.hasOwnProperty('error')) {
					if (data.body.length > 0) {
						let order_info = data.body;

						if (order_info[0].type_orderid == '1') {
							this.getRemainingLeads(order_info[0].id, order_info[0].status_orderid);
						}
						if (order_info[0].type_orderid == '3') {
							this.getRemainingHours(id, order_info[0].start_date, order_info[0].status_orderid, order_info[0].total_hours, order_info[0].id);
						}

					} else {
						this.requestApprovedLead();
					}
				}
			});
	}
	getRemainingLeads(id, status) {
		this.orderService.getRemainingLeads(id)
			.subscribe((data: any) => {
				if (!data.hasOwnProperty('error')) {
					if (data.body.records.length > 0) {

						let remaining = (parseInt(data.body.records[0].remaining_total) - 1)

						if (status == '2' || status == '4') {
							if (remaining == 0) {
								this.orderService.change_status_order(id, 4, null, 0, this.user.IdUser, 1).subscribe(data => {
									this.requestApprovedLead();
								}
								);
							}
							if (remaining < 0) {
								Swal.fire({
									title: "Message",
									text: "The campaign is complete, do you want to save another lead?",
									showCancelButton: true,
									confirmButtonText: "Yes",
									cancelButtonText: "Cancel",
								}).then((result) => {
									if (result.value) {
										this.orderService.change_status_order(id, 7, null, null, this.user.IdUserUser, 1) //overload open
										this.requestApprovedLead();
									} else {
										this.router.navigate(['admin/leads']);
									}
								});
							} else if (remaining > 0) {
								this.requestApprovedLead();
							}
						} else {
							if (status == 7) {
								this.requestApprovedLead();
							} else {
								Swal.fire({
									title: "Message",
									text: "The order is closed, in this case the lead doesn't can approveded.",
									showCancelButton: false,
									confirmButtonText: "Yes",
									cancelButtonText: "Cancel",
								});
								this.router.navigate(['admin/leads']);
							}
						}
					}
				}
			});
	}
	getRemainingHours(campaign, start_date, status, total_hours, orden) {
		this.orderService.getHoursCampaign(campaign, start_date)
			.subscribe((data: any) => {
					if (data.body.records.length > 0) {
						let remaining = parseInt(total_hours) - parseFloat(data.body.records[0].sum_time)

						if (status == '2' || status == '4') {
							if (remaining == 0) {
								this.orderService.change_status_order(orden, 4, null, 0, this.user.IdUser, 3).subscribe(data => {
									this.requestApprovedLead();
								}
								);
							}

							if (remaining < 0) {
								Swal.fire({
									title: "Message",
									text: "The campaign is complete, do you want to save another lead?",
									showCancelButton: true,
									confirmButtonText: "Yes",
									cancelButtonText: "Cancel",
								}).then((result) => {
									if (result.value) {
										this.orderService.change_status_order(orden, 7, null, null, this.user.IdUser, 3) //overload open
										this.requestApprovedLead();
									}
								});
							}
							else {
								this.requestApprovedLead();
							}
						} else {
							if (status == 7) {
								this.requestApprovedLead();
							} else {
								Swal.fire({
									title: "Message",
									text: "The order is closed, in this case the lead doesn't can approveded.",
									showCancelButton: false,
									confirmButtonText: "Yes",
									cancelButtonText: "Cancel",
								});
								this.router.navigate(['admin/leads']);
							}
						}
					}

			});
	}

	fixLeadById() {
		this.leadLoading = true;
		const payload = { lead_id: this.leadId, user: this.user.Login }

		this.leadSrv.fixLead(payload).subscribe(
			data => {
				Swal.fire({
					icon: 'success',
					title: 'Lead Correctly set to Fix'
				});
				this.lead.lead_status = 'Fix';
				this.leadLoading = false;
			},
			error => {
				Swal.fire({
					icon: 'error',
					title: 'Error changing lead status to fix ',
					text: 'See the console for further information'
				});
				console.error('Error approving lead:', error);
				this.leadLoading = false;

			}
		);
	}

	denyLead() {
		this.leadLoading = true;
		const payload = { lead_id: this.leadId, user: this.user.Login, campaign_id: this.campaignId, user_id: this.user.IdUser }

		this.leadSrv.denyLead(payload).subscribe(
			data => {
				Swal.fire({
					icon: 'success',
					title: 'Lead Correctly Denied'
				});
				this.lead.lead_status = 'Denied';
				this.leadLoading = false;
			},
			error => {
				Swal.fire({
					icon: 'error',
					title: 'Error denying lead ',
					text: 'See the console for further information'
				});
				console.error('Error denying lead:', error);
				this.leadLoading = false;

			}
		);
	}

	goToProspect(campaign, prospect) {
		this.router.navigate(['/caller/lead-profile'], { queryParams: { campaign, prospect } });
	}

	goToQcNotes() {
		this.activeTab = 'qc_notes';
		this.getPosibleReplaceLeads();
	}


	setReplacementStatus(status) {
		const payload = {
			lead_id: this.lead.id,
			prospect_company: this.lead.prospect_company,
			status: status,
			user: this.user.Login,
			user_id: this.user.IdUser
		};

		Swal.fire({
			title: 'Are you sure?',
			text: 'To set this lead as ' + status,
			showCancelButton: true,
			confirmButtonText: 'Ok',
			cancelButtonText: 'Cancel'
		}).then((result) => {
			if (result.value) {
				Swal.fire({
					title: status != 'QC Calls' ? 'Sending email' : 'Changing Status',
					text: '',
					confirmButtonText: 'Ok',
					didOpen: () => {
						Swal.showLoading();
						this.leadSrv.setReplacementStatus(payload).subscribe(data => {
							Swal.close();
							this.getLeadById();
							Swal.fire({
								title: 'Success',
								text: 'Lead set as ' + status,
								showCancelButton: false,
								confirmButtonText: 'Ok',
								cancelButtonText: 'Cancel'
							});
						});
					}
				});

			}
		});
	}

	replaceLeadBy() {
		const payload = {
			lead_id: this.lead.id,
			replaced_by: this.lead.replaced_by,
			replacement_status: this.lead.replacement_status,
			user: this.user.Login,
			user_id: this.user.IdUser
		}
		this.leadSrv.replaceLeadBy(payload).subscribe(data => {
			this.getLeadById();
			this.modalService.dismissAll();
			Swal.fire('Replaced',
				'Successfuly replaced',
				'success');
		});
	}

	unreplaceLead() {
		this.leadSrv.unreplaceLead(this.lead.id, this.user.IdUser).subscribe(data => {
			this.getLeadById();
			this.modalService.dismissAll();
			Swal.fire('Unreplaced',
				'Successfuly Unreplaced',
				'success');
		});
	}

	saveLead() {
		if (this.lead.confirmation_voicemail_date != null) {
			this.lead.confirmation_voicemail_date = this.utils.ngbDateToPHP(this.lead.confirmation_voicemail_date);
		}

		if (this.lead.contacted_date != null) {
			this.lead.contacted_date = this.utils.ngbDateToPHP(this.lead.contacted_date);
		}

		if (this.lead.remplaced_date != null) {
			this.lead.remplaced_date = this.utils.ngbDateToPHP(this.lead.remplaced_date);
		}

		if (this.lead.date_charged != null) {
			this.lead.date_charged = this.utils.ngbDateToPHP(this.lead.date_charged);
		}
		this.lead.edit_user = this.user.Login;
		const payload = this.lead;

		this.leadSrv.saveAll(payload).subscribe((data: any)=>{
			this.getLeadById();
			this.getQcLeadNotes();
			Swal.fire(
				'Saved!',
				'All data was saved',
				'success'
			);
		});
	}

	confirmLead(): void {
		Swal.fire({
			title: 'Confirming',
			text: '',
			confirmButtonText: 'Ok',
			didOpen: () => {
				Swal.showLoading();
				const payload = { ... this.lead, user_login: this.user.Login, user_id: this.user.IdUser }
				this.leadSrv.confirmLead(payload).subscribe((data: any)=>{
					Swal.close();
						if (!data.error) {
							this.lead.confirmation_date = data.body.confirmation_date;
							this.lead.confirmation = data.body.status;
							this.lead.confirmed_by = data.body.user_login;
						}
						this.leadLoading = false;
						Swal.fire({
							title: 'Success',
							text: 'Lead confirmed',
							showCancelButton: false,
							confirmButtonText: 'Ok',
							cancelButtonText: 'Cancel'
						});
				})

			}
		});
	}

	goToHistory() {
		this.leadLoading = true;
		this.activeTab = 'history';
		this.leadSrv.getLeadHistory(this.leadId).subscribe((data: any)=>{
			this.leadsChanges = data.body;
			this.leadLoading = false;
		});
	}

	addZerosDate(number) {
		number += 1;
		if (number < 10) {
			return '0' + number.toString();
		} else {
			return number.toString();
		}
	}

	getCallSheet() {
		this.campaign_info = null;
		this.activeTab = 'call_sheet';
		this.camapignInfoLoading = true;

		this.campaignSrv.getCampaignCallSheet(this.campaignId).subscribe((data:any)=>{
			this.campaign_info = data.body[0];
			this.camapignInfoLoading = false;
		});
	}


	getLeadFiles(tab) {
		this.loading = true;
		this.activeTab = tab;

		this.leadSrv.getLeadAttachments(this.lead.id).subscribe((data: any)=>{
			this.uploadedFiles = data.body;
			this.loading = false;
		})
	}



	onFileDropped(e) {
		this.loading = true;
		if (e.length > 0) {
			this.loader = true;
			let form = new FormData();
			form.append('leadId', this.lead.id);

			for (let index = 0; index < e.length; index++) {
				let name = 'file' + index;
				form.append(name, e[index]);
			}

			this.leadSrv.uploadFile(form).subscribe((data: any)=>{
				this.getLeadFiles('attachments');
			});
		}
	}

	showPdf(base64, name) {

		const linkSource = 'data:application/pdf;base64,' + base64;
		const downloadLink = document.createElement("a");
		const fileName = name;

		downloadLink.href = linkSource;
		downloadLink.download = fileName;
		downloadLink.click();
	}


	downloadFile(name) {
		const payload = { lead_id: this.lead.id, name: name }
		this.leadSrv.downloadFile(payload).subscribe((data: any)=>{
			this.showPdf(data.base64file, data.name);
		});
	}

	showUploadFiles() {
		this.showing = 'Files';
	}

	showURLs() {
		this.showing = 'URLs';
	}

	deleteFile(fileId, name) {
		this.loading = true;
		const payload = { file_id: fileId, name: name, lead_id: this.lead.id};
		this.leadSrv.deleteFile(payload).subscribe((data:any)=>{
			this.getLeadFiles('attachments');
		});
	}

	open(content) {
		this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'lg', centered: true}).result.then((result) => {
			this.closeResult = `Closed with: ${result}`;
		}, (reason) => {
			this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
		});
	}

	private getDismissReason(reason: any): string {
		if (reason === ModalDismissReasons.ESC) {
			return 'by pressing ESC';
		} else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
			return 'by clicking on a backdrop';
		} else {
			return `with: ${reason}`;
		}
	}


	public askRescheduleLeadAdmin() {

		this.reschedule.lead_id = this.lead.id;

		let old_date = this.lead.date_generated.split(' ');
		this.reschedule.new_date.time = old_date[1];

		this.reschedule.resolved_by = this.user.IdUser;

		this.reschedule.newTime = this.utils.ngbTimeToPHP(this.newTime);
		this.reschedule.new_date = this.utils.ngbDateToPHP(this.reschedule.new_date) + this.reschedule.newTime;

		this.reschedule.alias = this.user.Login;
		this.reschedule.calendar_id = this.lead.calendar_id;
		this.reschedule.user_login = this.user.Login;
		this.reschedule.user_id = this.user.IdUser;


		const loaderText = this.reschedule.send_notification ? 'Sending email' : 'Saving';

		Swal.fire({
			title: 'Rescheduling',
			text: loaderText,
			confirmButtonText: 'Ok',
			didOpen: () => {
				Swal.showLoading();
				this.leadSrv.rescheduleQa(this.reschedule).subscribe((data: any)=>{
					Swal.close();
					Swal.fire('Rescheduled',
						'Successfuly rescheduled',
						'success');
					this.getLeadById();
					this.modalService.dismissAll();
					this.reschedule = {
						id: null,
						lead_id: 0,
						alias: '',
						new_date: null,
						newHour: '06',
						newMin: '00',
						ampm: 'PM',
						reason: '',
						status: 'Pending',
						resolved_by: null,
						newTime: '',
						calendar_id: null,
						user_login: null,
						user_id: null,
						send_notification: false
					}
				});
			}
		});
	}

	checkHour() {
		if (parseInt(this.reschedule.newHour) > 12) {
			this.badHour = true;

		} else {
			this.badHour = false;
		}

		if (parseInt(this.reschedule.newMin) > 59) {
			this.badMin = true;
		} else {
			this.badMin = false;
		}
	}

	public Time24To12(date: String, time: String) {
		var FormatTime = new Date((date + ' ' + time));
		var infoTime;
		infoTime = FormatTime.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
		return infoTime;
	}

	copyMessage(val: string) {
		const selBox = document.createElement('textarea');
		selBox.style.position = 'fixed';
		selBox.style.left = '0';
		selBox.style.top = '0';
		selBox.style.opacity = '0';
		selBox.value = val;
		document.body.appendChild(selBox);
		selBox.focus();
		selBox.select();
		document.execCommand('copy');
		document.body.removeChild(selBox);
	}


	setAndBack(from) {
		switch (from) {
			case 'qc':
				this.searchAgentLogin = this.route.snapshot.queryParams['searchAgentLogin'];
				this.searchCampaignId = this.route.snapshot.queryParams['searchCampaignId'];

				this.dateOf = this.route.snapshot.queryParams['dateOf'];
				this.fromDate = this.route.snapshot.queryParams['fromDate'];
				this.toDate = this.route.snapshot.queryParams['toDate'];
				this.toView = this.route.snapshot.queryParams['toView'];
				break;
			case 'acc_review':
				this.fromDate = this.route.snapshot.queryParams['fromDate'];
				this.toDate = this.route.snapshot.queryParams['toDate'];
				this.user_id = this.route.snapshot.queryParams['user_id'];
				this.backUrl = 'user-client-edit';
				break;

			default:
				break;
		}

	}

	getPosibleReplaceLeads() {
		this.leadSrv.getPossibleReplacements(this.lead.alias).subscribe((data: any)=>{
			this.posibleReplaceLeads = data.body;
		});
	}

	public backButton() {
		this.saveLead();
	}

	public clearQcNotes() {
		if (!this.wasClear) {
			this.lead.qc_notes = '';
			this.wasClear = true;
		}
	}


	openRescheduleModal(othermodal) {
		// this.modalService.open(othermodal, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
		//   this.closeResult = `Closed with: ${result}`;
		// }, (reason) => {
		//   this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
		// });
	}

	openReplaceModal(othermodal) {
		this.modalService.open(othermodal, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
			this.closeResult = `Closed with: ${result}`;
		}, (reason) => {
			this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
		});
	}

	// FACES

	public selectedFace: string = '';
	public client_feedback: string = '';
	public answered: any = null;


	getAllDisposByPrimaryPhone(primary_phone) {

		this.allDispos = [];
		this.msgDispos = [];
		this.leadDispos = [];
		this.lastNote = '';

		this.prospectSrv.getDisposByPhone(primary_phone).subscribe((data: any) => {
			this.allDispos = data.body;
			for (let dispo of this.allDispos) {
				if (dispo.dispo === 'MSG') {
					this.msgDispos.push(dispo);
				}

				if (dispo.dispo === 'LEADF' || dispo.dispo === 'LEADP' || dispo.dispo === 'FACE' || dispo.dispo === 'PHONE' || dispo.dispo === 'ZOOM' || dispo.dispo === 'FIX') {
					this.leadDispos.push(dispo);
				}
			}
		});
	}

	showRescheduleButton() {
		const today = new Date().getTime();
		const apptDate = new Date(this.lead.date_generated);
		let twoDaysLater = new Date(this.lead.date_generated);
		twoDaysLater.setDate(twoDaysLater.getDate() + 2);

		if (today > apptDate.getTime()) {
			if (today < twoDaysLater.getTime()) {
				this.showRescheduleBtn = true;
			}
		}
	}

	submitNotes() {
		this.loadingSaveNote = true;
		if (this.formData.client_notes_area != '') {
			this.leadSrv.saveClientNotesByLead(this.leadId, this.formData.client_notes_area, this.client_input)
				.subscribe(
					data => {
						if (data.success) {
							this.messageSuccess = "Notes saved successfully";
							this.get_customer_notes_bylead();
						} else {
							this.messageError = "The data doesn't save, please check with support area"
						}
						this.loadingSaveNote = false;
						this.formData.client_notes_area = '';
					},
					() => {
						this.loadingSaveNote = false;
					}
				);
		} else {
			Swal.fire({
				title: 'Please write some comments to save',
				icon: 'warning',
				confirmButtonText: 'ok'
			});

			this.loadingSaveNote = false;
		}
	}

	onDragOver(event: DragEvent) {
		event.preventDefault(); // Evita que el navegador maneje el evento por defecto

		const dropzone = document.querySelector('.dropzone');
		if (dropzone) {
			dropzone.classList.add('dragging');
		}
	}

	onDragLeave(event: DragEvent) {
		event.preventDefault();
		const dropzone = document.querySelector('.dropzone');
		if (dropzone) {
			dropzone.classList.remove('dragging');
		}
	}

	sendSurvey() {
		Swal.fire({
			title: `Confirm`,
			text: `Are you sure you want to send the survey?`,
			showCancelButton: true,
			confirmButtonText: 'Send',

		}).then(data => {
			this.leadSrv.send_survey(this.lead.id, this.lead.prospect_company, this.lead.start_date, this.lead.start_time, this.lead.campaign_name, this.lead.email, this.lead.email_user).subscribe((data: any) => {
				Swal.fire('The survey has been sent');
			});
		})
	}

	resendEmail() {
		Swal.fire({
			title: 'Resend Email',
			text: `Are you sure you want to resend the approval email to ${this.lead.prospect_company}?`,
			showCancelButton: true,
			confirmButtonText: 'Send',
		}).then(result => {
			if (result.value) {
				const payload = {
					leadId: this.lead.id,
					prospect_company: this.lead.prospect_company,
					appt_date: this.lead.start_date,
				};
				Swal.fire({
					title: 'Sending email...',
					didOpen: () => {
						Swal.showLoading();
						this.leadSrv.resendLeadApprovedEmail(payload).subscribe(
							() => {
								Swal.close();
								Swal.fire({ icon: 'success', title: 'Email sent successfully' });
							},
							() => {
								Swal.close();
								Swal.fire({ icon: 'error', title: 'Error sending email', text: 'Please try again or contact support.' });
							}
						);
					}
				});
			}
		});
	}

	denyReschedule() {

		Swal.fire({
			title: 'Deny Reschedule',
			text: `Are you sure you want to deny this reschedule?`,
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: "Send notification to the client"
		}).then(data => {

			this.rescheduleService.denyReschedule(this.lead.id, this.lead.alias, this.user.IdUser).subscribe(data => {
				this.getLeadById();
			})
		})
	}

	denyReplacement() {

		Swal.fire({
			title: 'Deny Replacement',
			text: `Are you sure you want to deny this replacement?`,
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: "Send notification to the client"
		}).then(data => {

			this.replacementSrv.denyReplacement(this.lead.id, this.lead.alias, this.user.IdUser).subscribe(data => {
				this.getLeadById();
			})
		})
	}

	sendCalendarInvite() {

		const dataZapier = {
			"id": this.lead.id,
			"prospect_company": this.lead.prospect_company,
			"start_date": this.lead.start_date,
			"start_time": this.lead.start_time,
			"end_date": this.lead.end_date,
			"end_time": this.lead.end_time,
			"campaign_name": this.lead.campaign_name,
			"message": "Meet with ",
			email_prospect: this.lead.email,
			email_client: this.lead.email_user,
			// "email_prospect": "mtorre@t3direct.com",
			// "email_client": "mtorre@t3direct.com",
		};

		let headers = new HttpHeaders({
			'Content-Type': 'application/x-www-form-urlencoded'
		});
		let options = {
			headers: headers
		}
		const webhookUrl = 'https://hooks.zapier.com/hooks/catch/2314556/3cx31jd/'

		this.http.post(webhookUrl, dataZapier, options)
			.subscribe(data => {
				console.info(data);
			});


		Swal.fire({
			title: `Confirm`,
			text: `Are you sure you want to send the invite?`,
			showCancelButton: true,
			confirmButtonText: 'Send'
		}).then(data => {

			this.http.post(webhookUrl, dataZapier, options)
				.subscribe(data => {
					Swal.fire('The survey has been sent');
				},
					error => {
						console.error('Error al enviar datos a Zapier:', error);
					}
				);
			// this.leadSrv.send_calendar_invite(dataZapier)
			// 	.subscribe(response => {
			// 	  Swal.fire('The survey has been sent');
			// 	},
			// 	error => {
			// 	  console.error('Error al enviar datos a Zapier:', error);
			// 	}
			// );

		})
	}

	getDispoLogNotes(){
		this.leadSrv.getDispoLogNotes(this.lead.prospect_id).subscribe((data: any)=>{
			this.notes = data.body;
			this.copyNotes = this.notes[0].notes;
		});
	}

	getQcLeadNotes(){
		this.leadSrv.getQcLeadNotes(this.leadId).subscribe((data: any)=>{
			this.notes_qc = data.body;
			this.notes_qc = this.notes_qc.map(note => {
				const utcDate = new Date(note.creation_date);
				const localDate = new Date(utcDate.getTime() - utcDate.getTimezoneOffset() * 60000);
				const formattedDate = dayjs(localDate).format('YYYY-MM-DD HH:mm:ss');
				return { ...note, creation_date: formattedDate };
			});
		});
	}

}
